import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CircleButton = ({ icon, className, handlerClick }) => (
  <button
    type="button"
    className={`btn-circle ${className || ""}`}
    onClick={handlerClick}
  >
    <FontAwesomeIcon icon={icon} />
  </button>
);

CircleButton.defaultProps = {
  className: "",
};

CircleButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  handlerClick: PropTypes.func.isRequired,
};

export default CircleButton;
